import α from 'color-alpha';
import { i18n, TFunction } from 'i18next';

import { uiHelpers } from '../../../helpers';
import { PriceDataPointWithPreviousClose } from '../../../types';
import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';

class Turnover extends DataSetSeriesGenerator {
  isSeparateFromPriceChart = false;
  forceShowYAxisLabels: boolean;
  display: boolean;
  bearishColor: string;
  bullishColor: string;

  i18n: i18n;

  constructor(
    display: boolean,
    bullishColor: string,
    bearishColor: string,
    t: TFunction,
    i18n: i18n
  ) {
    super(t);
    this.display = display;
    this.forceShowYAxisLabels = !display;
    this.bullishColor = bullishColor;
    this.bearishColor = bearishColor;
    this.i18n = i18n;
  }

  yAxisFormatter = (value: number): string =>
    uiHelpers.formatLargeMoney(this.i18n, value);

  getChartName(): string {
    return this.t('Turnover');
  }

  visualMap = (): echarts.EChartOption.VisualMap => ({
    type: 'piecewise',
    show: false,
    dimension: 2,
    pieces: [
      {
        value: 1,
        color: this.bullishColor,
      },
      {
        value: -1,
        color: this.bearishColor,
      },
      {
        value: 0,
        color: α('grey', 0.7),
      },
    ],
  });

  getSeries(
    dataPoints: ReadonlyArray<PriceDataPointWithPreviousClose>
  ): PriceViewerSeries {
    const values: [string, number, number][] = dataPoints.map(item => [
      item.date as string, // Bug in @types/echarts where date can only be string (but should be Date | string instead according to docs)
      item.turnover,
      this.display
        ? item.close > (item.previousClose || item.open)
          ? 1
          : -1
        : 0,
    ]);
    return {
      name: this.getChartName(),
      echartSeries: {
        data: values,
        type: this.display ? 'line' : 'bar',
        symbol: 'none',
        lineStyle: {
          color: 'rgba(255,255,255,0)',
        },
      },
      tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
        keyColor: 'grey',
      }),
    };
  }
}

export default Turnover;
